import React from 'react'
import "./Banner_heading.css"

function Banner_heading({ heading_text_1, span_tag, heading_text_2 }) {
    return (
        <>
            <section className="Banner_heading">
                <h4>{heading_text_1}<span>{span_tag}</span><br />{heading_text_2}</h4>
            </section>
        </>
    )
}

export default Banner_heading